export default function MonitoredInterfaceDetail() {
    return <div>MonitoredInterfaceDetail</div>;
}
